<template>
    <div class="d-flex flex-column h-100">
        <SelectObjective
            :existentSelectedObjectiveId="form.objective_id"
            :label="$t('objectives.availableObjectives')"
            @updateValue="saveAlreadySelectedObjectiveInForm($event)"
            ref="selectObjective"
        />

        <div class="ml-auto mt-auto">
            <b-button variant="outline-primary" class="mr-2" :disabled="isSubmitting" @click="onClickCancel">{{
                $t('form.button.cancel')
            }}</b-button>
            <button-loader
                variant="primary"
                :disabled="localIsSubmitting"
                :loader="localIsSubmitting"
                @click="onClickSubmit"
            >
                {{ $t('form.button.save') }}
            </button-loader>
        </div>
    </div>
</template>

<script>
import SelectObjective from '../../../objective/link-objective/components/SelectObjective.vue'
import { validationMixin } from 'vuelidate'
import required from 'vuelidate/lib/validators/required'
import ButtonLoader from '@/views/components/button-loader'
import { danger } from '@/lib/notification'

export default {
    mixins: [validationMixin],
    components: {
        SelectObjective,
        ButtonLoader,
    },
    props: {
        isSubmitting: {
            type: Boolean,
            required: true,
        },
    },
    validations: {
        form: {
            objective_id: { required },
        },
    },
    data() {
        return {
            localIsSubmitting: this.isSubmitting,
            form: {
                objective_id: null,
            },
        }
    },
    created() {},
    watch: {
        '$route.query.objectiveId': function (newObjectiveId) {
            this.form.objectiveId = newObjectiveId
        },
    },
    methods: {
        saveAlreadySelectedObjectiveInForm(objective) {
            if (objective && objective.value) {
                this.form.objective_id = objective.value
            }
        },
        onClickCancel() {
            this.$emit('cancel')
        },
        onClickSubmit() {
            if (!this.form.objective_id) {
                this.showErrorNotification()
            } else {
                this.localIsSubmitting = true
            }

            if (!this.formIsValid()) {
                return
            }

            const form = this.getParsedForm()
            this.$emit('submit', form)
        },
        formIsValid() {
            this.$v.$touch()
            return this.$v.$invalid == false
        },
        getParsedForm() {
            return {
                objective_id: this.form.objective_id,
            }
        },
        showErrorNotification() {
            danger(this.$t('notification.selectSomeGoal'))
        },
    },
}
</script>

<style lang="scss" scoped>
.label-style {
    color: #022b4f;
    font-size: 16px;
    font-weight: 700;
}

::v-deep legend {
    @extend .label-style;
}

::v-deep label {
    @extend .label-style;
}
</style>
